__turbopack_context__.v({
  "buttonGroup": "error-boundary-module-scss-module__4GNf4a__buttonGroup",
  "card": "error-boundary-module-scss-module__4GNf4a__card",
  "container": "error-boundary-module-scss-module__4GNf4a__container",
  "copyButton": "error-boundary-module-scss-module__4GNf4a__copyButton",
  "details": "error-boundary-module-scss-module__4GNf4a__details",
  "detailsContent": "error-boundary-module-scss-module__4GNf4a__detailsContent",
  "detailsSummary": "error-boundary-module-scss-module__4GNf4a__detailsSummary",
  "emailButton": "error-boundary-module-scss-module__4GNf4a__emailButton",
  "errorMessage": "error-boundary-module-scss-module__4GNf4a__errorMessage",
  "errorName": "error-boundary-module-scss-module__4GNf4a__errorName",
  "errorStack": "error-boundary-module-scss-module__4GNf4a__errorStack",
  "icon": "error-boundary-module-scss-module__4GNf4a__icon",
  "iconWrapper": "error-boundary-module-scss-module__4GNf4a__iconWrapper",
  "message": "error-boundary-module-scss-module__4GNf4a__message",
  "retryButton": "error-boundary-module-scss-module__4GNf4a__retryButton",
  "title": "error-boundary-module-scss-module__4GNf4a__title",
});
